import { createContext } from 'react'
import { noop } from 'utils/general'

export const DropdownContext = createContext<{
  onItemSelected: () => void
}>({ onItemSelected: noop })
